import { Button, CircularProgress, Typography } from "@material-ui/core";
import React, { useContext, useState } from "react";
import { useHistory, useLocation } from "react-router";
import TokenService from "../Base/Services/TokenService";
import UserService from "../Base/Services/UserService";
import { AuthContext } from "./AuthContextProvider";

function findOrCreateUser() {
  return UserService.getAuthenticatedUser().catch((err) => {
    // If 404, no existing user was found. Create one!
    if (err?.response?.status === 404) {
      return UserService.createUser();
    }
    throw err;
  });
}

/**
 * After loggin in to UtahID, the user will be redirected to this component.
 * The URL query string will have a code that can be used to get an access token.
 */
export default function AuthRedirect() {
  const authContext = useContext(AuthContext);
  const location = useLocation();
  const history = useHistory();

  const [authSuccess, setAuthSuccess] = useState();

  React.useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const authCode = queryParams.get("code");
    const responseAuthState = queryParams.get("state");

    if (authCode && responseAuthState) {
      if (responseAuthState !== TokenService.getSingleUseStoredAuthState()) {
        // Verify that the state that is sent back is the same we sent them!
        // If the state isn't the same as we sent them, then this could be an XSRF attack
        console.error("Invalid authentication state");
        setAuthSuccess(false);
        return;
      }

      TokenService.getAccessTokens(authCode)
        .then((accessTokensResponse) => {
          // access_token will be returned on success
          if (accessTokensResponse.access_token) {
            return findOrCreateUser().then((userInfo) => {
              authContext.setUserInfo(userInfo);
              history.replace("/");
            });
          } else {
            setAuthSuccess(false);
          }
        })
        .catch((e) => {
          console.error(e);
          setAuthSuccess(false);
        });
    } else if (!authCode || !responseAuthState) {
      // If no code or state was sent back, auth was unsuccessful
      setAuthSuccess(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      {authSuccess === false ? (
        <>
          <p>There was an error logging you in!</p>
          <Button onClick={() => authContext.navigateToUtahIDLogin()}>Please try logging in again.</Button>
        </>
      ) : (
        <>
          <CircularProgress variant="indeterminate" style={{ margin: 36 }} />
          <Typography variant="h2">Loading your profile...</Typography>
        </>
      )}
    </div>
  );
}
